import { ref, customRef, reactive, onMounted, onUnmounted } from 'vue'
import md5 from 'md5'
import moment from 'moment'
import { fabric } from 'fabric'

export function createPutObject(fileName, path = 'upload') {
  var ext = getFileExt(fileName)
  var result = md5(fileName + Math.random()) + '.' + ext
  if (path) {
    result = path + '/' + moment().format('YYYYMMDD') + '/' + result
  }
  return result
}

export function loadImage(src) {
  return new Promise((resolve, reject) => {
    let image = new Image()
    image.onload = function () {
      resolve(image)
    }
    image.onerror = function () {
      reject('loadImage error')
    }
    image.src = src
  })
}

export function loadVideoFile(file) {
  return new Promise((resolve, reject) => {
    let video = document.createElement('video')
    video.preload = 'metadata'

    video.onloadedmetadata = function () {
      resolve(video)
    }

    video.onerror = function () {
      reject('loadVideoFile Error')
    }

    video.src = window.URL.createObjectURL(file)
  })
}

function getFileExt(filePath) {
  var startIndex = filePath.lastIndexOf('.')
  if (startIndex != -1) {
    return filePath.substring(startIndex + 1, filePath.length).toLowerCase()
  } else {
    return ''
  }
}

export function getFileName(filename) {
  try {
    return filename.substring(0, filename.lastIndexOf('.'))
  } catch (error) {
    return ''
  }
}

export function fontFamily(font_family) {
  let data = {
    'SourceHanSans-Normal.otf': 'font1',
    'SourceHanSans-Bold.otf': 'font2',
    '庞门正道标题体2.0增强版.ttf': 'font3',
    '站酷快乐体.ttf': 'font4',
    '站酷高端黑.ttf': 'font5',
    'SourceHanSansCN-Regular.otf': 'font6',
    'SourceHanSerifTW-Bold.otf': 'font7',
    'SourceHanSerifTW-Regular.otf': 'font8',
    '字魂55号-龙吟手书.ttf': 'font9',
    '字魂143号-正酷超级黑.ttf': 'font10',
    '字魂151号-联盟综艺体.ttf': 'font11',
  }
  return data[font_family]
}

export function fontFamilyOptions() {
  let data = [
    {
      name: '思源黑体-Normal',
      value: 'SourceHanSans-Normal.otf',
    },
    {
      name: '思源黑体-Bold',
      value: 'SourceHanSans-Bold.otf',
    },
    {
      name: '庞门正道标题体2.0增强版',
      value: '庞门正道标题体2.0增强版.ttf',
    },
    {
      name: '站酷高端黑',
      value: '站酷高端黑.ttf',
    },
    {
      name: '站酷快乐体',
      value: '站酷快乐体.ttf',
    },
    {
      name: 'SourceHanSansCN-Regular',
      value: 'SourceHanSansCN-Regular.otf',
    },
    {
      name: 'SourceHanSerifTW-Bold',
      value: 'SourceHanSerifTW-Bold.otf',
    },
    {
      name: 'SourceHanSerifTW-Regular',
      value: 'SourceHanSerifTW-Regular.otf',
    },
    {
      name: '字魂55号-龙吟手书',
      value: '字魂55号-龙吟手书.ttf',
    },
    {
      name: '字魂143号-正酷超级黑',
      value: '字魂143号-正酷超级黑.ttf',
    },
    {
      name: '字魂151号-联盟综艺体',
      value: '字魂151号-联盟综艺体.ttf',
    },
  ]
  return data
}

export function create_preview_url(id, oid) {
  return `${process.env.VUE_APP_baseURL}/Allnettpl/template_preview.html?id=${id}&oid=${oid}`
}

export function summaryHandle(param, column_property = ['money']) {
  const { columns, data } = param
  const sums = []

  data.length &&
    columns.forEach((column, index) => {
      if (index > 0 && column_property.includes(column.property)) {
        let sum = `${data.reduce((prev, curr) => {
          const value = Number(curr[column.property])
          if (!Number.isNaN(value)) {
            return prev + value
          } else {
            return prev
          }
        }, 0)}`
        sums[index] = Math.floor(sum * 100) / 100
      } else {
        sums[index] = ''
      }
    })

  return sums
}

export function useDebouncedRef(value, delay = 200) {
  let timeout
  return customRef((track, trigger) => {
    return {
      get() {
        track()
        return value
      },
      set(newValue) {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          value = newValue
          trigger()
        }, delay)
      },
    }
  })
}

export function debounceSearch(fields, delay = 600) {
  let timer = null
  const search = ref('')
  const searchHandle = (value) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fields.search = value
    }, delay)
  }
  return {
    search,
    searchHandle,
  }
}

export function is_oem(userInfo = {}) {
  let result =
    location.hostname !== 'localhost' && location.hostname !== 'u.xiansuotu.com'
  if (
    userInfo?.user?.oem_domain &&
    location.hostname !== userInfo.user.oem_domain
  ) {
    result = false
  }
  return result
}

export function postExcelFile(params, url) {
  var form = document.createElement('form')
  form.style.display = 'none'
  form.action = url
  form.method = 'post'
  document.body.appendChild(form)
  for (var key in params) {
    var input = document.createElement('input')
    input.type = 'hidden'
    input.name = key
    input.value = params[key]
    form.appendChild(input)
  }
  form.submit()
  form.remove()
}

export const pid_config = {
  1: '抖音',
  2: '快手',
  3: '好看',
  4: '西瓜',
  5: '头条',
  6: '哔哩哔哩',
  7: '爱奇艺',
  8: '微博',
  9: '视频号',
  10: '小红书',
}

export const douyin_download_video = (url) =>
  process.env.VUE_APP_baseURL +
  '/api/douyin_download_video?url=' +
  encodeURIComponent(url)

export const douyin_download_audio = (url) =>
  process.env.VUE_APP_baseURL +
  '/api/douyin_download_audio?url=' +
  encodeURIComponent(url)

export const basename = (str) => {
  var idx = str.lastIndexOf('/')
  idx = idx > -1 ? idx : str.lastIndexOf('\\')
  if (idx < 0) {
    return str
  }
  return str.substring(idx + 1)
}

export const download = (url, name) => {
  const link = document.createElement('a')
  link.download = name ? name : basename(url)
  link.style.display = 'none'
  link.target = '_blank'
  link.href = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const test_account_hidden = (userInfo) => {
  return !userInfo || userInfo.id === 1258
}

export const file2src = (file) => {
  let url = file.url
  switch (file.type) {
    case 'video':
      url += '?x-oss-process=video/snapshot,t_10000,f_jpg,m_fast,ar_auto'
      break

    default:
      break
  }
  return url
}

export function fabricLoadImage(src, option = { crossOrigin: 'anonymous' }) {
  return new Promise((resolve, _reject) => {
    fabric.Image.fromURL(
      src,
      (image) => {
        resolve(image)
      },
      option
    )
  })
}

export function fabricImageScale(box, img, type = 'cover') {
  let top = 0
  let left = 0
  let scale = 1

  let box_ratio = box.width / box.height
  let img_ratio = img.width / img.height

  switch (type) {
    case 'cover':
      if (box_ratio >= img_ratio) {
        scale = box.width / img.width
        top = -(img.height * scale - box.height) / 2
      } else {
        scale = box.height / img.height
        left = -(img.width * scale - box.width) / 2
      }
      break
    case 'contain':
      if (box_ratio >= img_ratio) {
        scale = box.height / img.height
        left = (box.width - img.width * scale) / 2
      } else {
        scale = box.width / img.width
        top = (box.height - img.height * scale) / 2
      }
      break
  }

  if (box.top) {
    top += box.top
  }

  if (box.left) {
    left += box.left
  }

  return {
    top,
    left,
    originX: 'left',
    originY: 'top',
    scaleX: scale,
    scaleY: scale,
  }
}

export async function dataUrlToFile(dataUrl, fileName) {
  const res = await fetch(dataUrl)
  const blob = await res.blob()
  return new File([blob], fileName, { type: 'image/jpeg' })
}

export const cellStyle = ({ row, column, rowIndex, columnIndex }) => {
  if (column.align === null) {
    return { textAlign: 'center' }
  }
}

const AiFontEnum = [
  { id: 1, name: '阿里巴巴普惠体-纤细', value: '1.ttf' },
  { id: 3, name: '阿里巴巴普惠体-中黑', value: '3.ttf' },
  { id: 4, name: '阿里巴巴普惠体-粗体', value: '4.ttf' },
  { id: 5, name: '阿里巴巴普惠体-特粗', value: '5.ttf' },
  { id: 6, name: '思源宋体-常规', value: '6.otf' },
  { id: 7, name: '思源宋体-中粗', value: '7.otf' },
  { id: 8, name: '思源宋体-粗体', value: '8.otf' },
  { id: 9, name: '思源宋体-超粗', value: '9.otf' },
  { id: 10, name: '文道潮黑体', value: '10.ttf' },
  { id: 15, name: 'Aa剑豪体', value: '15.ttf' },
  { id: 16, name: '站酷小薇LOGO体', value: '16.otf' },
  { id: 17, name: '站酷酷黑体', value: '17.ttf' },
  { id: 18, name: '站酷高端黑体', value: '18.ttf' },
  { id: 19, name: '站酷庆科黄油体', value: '19.ttf' },
  { id: 20, name: '优设好身体', value: '20.ttf' },
  { id: 59, name: '江城圆体-常规', value: '59.ttf' },
  { id: 61, name: '斗鱼追光体', value: '61.ttf' },
  { id: 62, name: '仓耳小丸子', value: '62.ttf' },
  { id: 63, name: '仓耳周珂正大榜书', value: '63.ttf' },
  { id: 64, name: '仓耳非白-W01', value: '64.ttf' },
  { id: 65, name: '仓耳舒圆体-W02', value: '65.ttf' },
  { id: 66, name: '仓耳非白-W04', value: '66.ttf' },
  { id: 67, name: '仓耳渔阳体-W05', value: '67.ttf' },
  { id: 68, name: '演示悠然小楷', value: '68.ttf' },
  { id: 69, name: '庞门正道轻松体', value: '69.otf' },
  { id: 70, name: '胡晓波真帅体', value: '70.otf' },
  { id: 71, name: '字体传奇特战体', value: '71.ttf' },
  { id: 72, name: '杨任东竹石体', value: '72.ttf' },
  { id: 73, name: '胡晓波骚包体', value: '73.otf' },
  { id: 74, name: '胡晓波男神体', value: '74.otf' },
  { id: 75, name: '清松手写体', value: '75.ttf' },
  { id: 76, name: '花园宋体', value: '76.ttf' },
  { id: 77, name: '演示夏行楷', value: '77.ttf' },
  { id: 78, name: '庞门正道标题体', value: '78.ttf' },
  { id: 79, name: '站酷快乐体', value: '79.ttf' },
  { id: 80, name: '字体圈新意冠黑体', value: '80.ttf' },
  { id: 81, name: '字制区喜脉体', value: '81.otf' },
  { id: 82, name: '卓健橄榄简体', value: '82.ttf' },
  { id: 83, name: '演示秋鸿楷', value: '83.ttf' },
  { id: 84, name: '庞门正道粗书体', value: '84.ttf' },
  { id: 85, name: '沐瑶随心手写体', value: '85.ttf' },
  { id: 86, name: '沐瑶软笔手写体', value: '86.ttf' },
  { id: 87, name: '联盟起艺卢帅正锐黑体', value: '87.ttf' },
  { id: 88, name: '字体传奇南安体', value: '88.ttf' },
  { id: 89, name: '字体圈欣意吉祥宋', value: '89.ttf' },
  { id: 90, name: '峰广明锐体', value: '90.ttf' },
  { id: 91, name: '智勇手书体', value: '91.ttf' },
  { id: 92, name: '鸿雷板书简体', value: '92.ttf' },
  { id: 93, name: '演示佛系体', value: '93.ttf' },
  { id: 94, name: '站酷文艺体', value: '94.ttf' },
]

export function AiFontFamilyOptions() {
  let data = []
  for (const item of AiFontEnum) {
    const { id, name, value } = item
    data.push({
      id,
      name,
      img: require(`@/assets/aifont/${id}.png`),
      value,
      font: `aifont${id}`,
    })
  }
  return data
}

export function blob_download(data, filename = 'export.zip') {
  const blob = new Blob([data])
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()

  window.URL.revokeObjectURL(url)
}

export function combination(data = [], limit = 1000, result = [], cache = '') {
  if (data.length) {
    for (const v of data[0]) {
      if (result.length >= limit) break
      let value = cache + v
      let residue_data = data.slice(1)
      if (residue_data.length) {
        result = combination(residue_data, limit, result, value)
      } else {
        result.push(value)
      }
    }
  }

  return result
}

export function val2arr(val, regexp = /\n|,/, replace = /\s/g) {
  let arr = val.split(regexp)
  if (replace) {
    for (let index = 0; index < arr.length; index++) {
      arr[index] = arr[index].replace(replace, '')
    }
  }
  arr = [...new Set(arr)].filter((v) => v !== '')
  return arr
}

export function str_hide(str, start = 4, end = 4, placeholder = '*') {
  let result = str
    .split('')
    .reduce((previousValue, currentValue, currentIndex, array) => {
      if (currentIndex < start || currentIndex >= array.length - end) {
        return previousValue + currentValue
      } else {
        return previousValue + placeholder
      }
    }, '')
  return result
}

export function useEventListener(target, event, callback) {
  onMounted(() => target.addEventListener(event, callback))
  onUnmounted(() => target.removeEventListener(event, callback))
}

export function useResize() {
  const innerWidth = ref(window.innerWidth)

  useEventListener(window, 'resize', (event) => {
    innerWidth.value = window.innerWidth
  })

  return { innerWidth }
}

export function get_videoclip_url(id) {
  return process.env.NODE_ENV === 'development'
    ? `http://localhost:8081/videoclip/index/${id}`
    : `${window.location.origin}/videoclip/index/${id}`
}

export const open_work_id = async (row) => {
  if (row.pid === 1) {
    window.open(`https://www.sohu.com/a/${row.work_id}_${row.user_id}`)
  } else if (row.pid === 2) {
    window.open(`https://www.toutiao.com/item/${row.work_id}`)
  } else if (row.pid === 3) {
    window.open(`https://baijiahao.baidu.com/s?id=${row.work_id}`)
  }
}
